import { render } from "./PlansClinicDataOffcanvas.vue?vue&type=template&id=a0ae1c18&scoped=true"
import script from "./PlansClinicDataOffcanvas.vue?vue&type=script&lang=js"
export * from "./PlansClinicDataOffcanvas.vue?vue&type=script&lang=js"

import "./PlansClinicDataOffcanvas.vue?vue&type=style&index=0&id=a0ae1c18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0ae1c18"]])

export default __exports__